export const RECEIVE_METERS = 'RECEIVE_METERS';
export const GET_METERS = 'GET_METERS';
export const SET_METER = 'SET_METER';
export const UPDATE_METER = 'UPDATE_METER';
export const DELETE_METER = 'DELETE_METER';
export const FETCH_METERS = 'FETCH_METERS';
